// extracted by mini-css-extract-plugin
module.exports = {"root":"bl_bj"};